"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var IsServerSideRendering = function serverSideRenderCheck() {
  try {
    return typeof window === 'undefined';
  } catch (e) {
    return true;
  }
}();

var _default = IsServerSideRendering;
exports.default = _default;
module.exports = exports.default;